import Link from "next/link";
import Image from "next/legacy/image";
import {
  ArrowRight,
  Building,
  House,
  MapPin,
} from "@phosphor-icons/react/dist/ssr";

interface CuratedListProps {
  title: string;
  location: string;
  imageUrl: string;
  propertyCount: number;
  startingPrice: string;
  description: string;
  linkUrl: string;
  icon?: 'building' | 'house';
  category?: 'location' | 'lifestyle' | 'builder' | 'budget';
}

export default function CuratedList({
  title,
  location,
  imageUrl,
  propertyCount,
  startingPrice,
  description,
  linkUrl,
  icon = 'building',
  category
}: CuratedListProps) {
  const Icon = icon === 'building' ? Building : House;
  const isBuilder = category === 'builder';

  return (
    <div className="rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 w-[80vw] md:w-[280px] lg:w-[320px] xl:w-[360px] mx-auto md:mx-0 hover:scale-[1.02] transform">
      {/* Image section - hidden on mobile */}
      <div className="relative block h-36 md:h-48 lg:h-56 xl:h-64 overflow-hidden">
        <Image
          src={imageUrl}
          alt={title}
          layout="fill"
          className={`object-${isBuilder ? 'contain' : 'cover'} transition-transform duration-300 hover:scale-105 ${isBuilder ? 'bg-white p-4' : ''}`}
        />
        {!isBuilder && (
          <div className="absolute inset-0 bg-linear-to-t from-black/70 to-transparent flex items-end">
            <div className="p-3 text-white">
              <h3 className="text-base font-bold line-clamp-1">{title}</h3>
            </div>
          </div>
        )}
      </div>
      <div className="p-3 bg-white">
        <div className="flex justify-between items-center text-xs text-gray-600 mb-2">
          <span className="flex items-center">
            <Icon className="w-3 h-3 mr-1" />
            {propertyCount} Properties
          </span>
        </div>
        <p className="text-gray-600 text-xs mb-3 line-clamp-2">
          {description}
        </p>
        <Link
          href={linkUrl}
          className="btn btn-primary btn-sm w-full flex items-center justify-center gap-1 text-xs"
        >
          View listings
          <ArrowRight className="w-3 h-3" weight="bold" />
        </Link>
      </div>
    </div>
  );
}

